var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"custom-label-group-wrapper"},[_c('b-form-group',{staticClass:"custom-label-group",attrs:{"label":_vm.label,"label-for":_vm.labelFor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',{attrs:{"stacked":"","disabled":_vm.disabled,"id":_vm.labelFor,"options":_vm.options,"aria-describedby":ariaDescribedby,"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})]}}])})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22771035","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisation/BCustomSelect.vue
// module id = 1361
// module chunks = 1